import { okOrThrow } from "../../response.js";
import { acceptJson } from "../../shared.js";
const unlink = async (apiUrl, request) => {
  const { orderNumber, orderToken } = request;
  const response = await fetch(
    `${apiUrl}/orders/${orderNumber}/customer?orderDataToken=${orderToken}`,
    {
      method: "DELETE",
      headers: {
        ...acceptJson
      }
    }
  );
  okOrThrow(response);
  return response;
};
export {
  unlink
};
//# sourceMappingURL=unlink.js.map
